import { Box, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { FadeLoader } from 'react-spinners';

import { TLoaderProps } from '@/shared/components/ui/loader/loader.types';

export const Loader: React.FC<TLoaderProps> = ({ headline, loaderText }) => {
  const theme = useTheme();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      padding="2.5rem"
      gap="2.25rem"
    >
      <Box height="50px" width="50px">
        <FadeLoader color={theme.palette.primary.main} />
      </Box>
      {headline && (
        <Typography variant="h2" textAlign="center">
          {headline}
        </Typography>
      )}
      {loaderText && (
        <Typography textAlign="center" variant="p5" color="textSecondary">
          {loaderText}
        </Typography>
      )}
    </Stack>
  );
};
